import { render, staticRenderFns } from "./dyo_text.vue?vue&type=template&id=41691665&scoped=true"
import script from "./dyo_text.vue?vue&type=script&lang=js"
export * from "./dyo_text.vue?vue&type=script&lang=js"
import style0 from "./dyo_text.vue?vue&type=style&index=0&id=41691665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41691665",
  null
  
)

export default component.exports